export const stationMunicipalitiesTypes = {
  GET_STATION_MUNICIPALITIES_STATES: 'GET_STATION_MUNICIPALITIES_STATES',
  SET_STATION_MUNICIPALITIES_FILTERS: 'SET_STATION_MUNICIPALITIES_FILTERS',
  GET_STATION_MUNICIPALITIES: 'GET_STATION_MUNICIPALITIES',
  CREATE_STATION_MUNICIPALITIES: 'CREATE_STATION_MUNICIPALITIES',
  DELETE_STATION_MUNICIPALITIES: 'DELETE_STATION_MUNICIPALITIES',
  CLEAR_STATION_MUNICIPALITIES: 'CLEAR_STATION_MUNICIPALITIES',
  SET_CONFIG_FILTER_STATION_MUNICIPALITIES: 'SET_CONFIG_FILTER_STATION_MUNICIPALITIES',
  SET_CONFIG_PAGE_STATION_MUNICIPALITIES: 'SET_CONFIG_PAGE_STATION_MUNICIPALITIES',
  SET_CONFIG_PAGE_SIZE_STATION_MUNICIPALITIES: 'SET_CONFIG_PAGE_SIZE_STATION_MUNICIPALITIES',
  SET_CONFIG_SORTED_STATION_MUNICIPALITIES: 'SET_CONFIG_SORTED_STATION_MUNICIPALITIES'
}